import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faHeadset } from '@fortawesome/pro-solid-svg-icons';
import AudioAnalyzer from './AudioAnalyzer';

class MicTest extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      audio: null,
      ref: React.createRef(),
    };
  }

  getMicrophone = async () => {
    const { ref } = this.state;

    // Create the mic's audio stream.
    const audio = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: false,
    });
    this.setState({ audio });

    // Play the audio stream.
    ref.current.srcObject = audio;
    ref.current.play();
  };

  stopMicrophone = () => {
    const { audio } = this.state;

    audio.getTracks().forEach((track) => track.stop());
    this.setState({ audio: null });
  };

  toggleMicrophone = () => {
    const { audio } = this.state;

    if (audio) {
      this.stopMicrophone();
    } else {
      this.getMicrophone();
    }
  };

  render() {
    const { audio, ref } = this.state;
    const {
      text = 'Test Headset',
      className = '',
    } = this.props;

    /* eslint-disable jsx-a11y/media-has-caption */
    return (
      <>
        <audio ref={ref} />

        {audio ? (
          <div
            className="me-2 d-flex align-items-center"
            style={{ height: '38px' }}
          >
            <button
              type="button"
              className="btn btn-link"
              onClick={this.toggleMicrophone}
            >
              <FontAwesomeIcon
                icon={faTimesCircle}
                size="lg"
              />
            </button>
            <AudioAnalyzer audio={audio} />
          </div>
        ) : (
          <button
            type="button"
            className={['btn btn-outline-secondary', className].join(' ')}
            onClick={this.toggleMicrophone}
          >
            <FontAwesomeIcon className="me-2" icon={faHeadset} />
            {text}
          </button>
        )}
      </>
    );
  }
}

export default MicTest;
